import { createTimeObject } from "./ObjectHelpers";

function getTimeHours() {
    let arrHours = [];

    let currentHour = 0;
    while (currentHour < 24) {
        arrHours.push(createTimeObject(currentHour));
        currentHour++;
    }

    return arrHours;
}

function getTimeMinutes(isTime = true) {
    let arrMinutes = [];

    let currentMinute = 0;
    const max = isTime ? 60 : 125;

    while (currentMinute < max) {
        arrMinutes.push(createTimeObject(currentMinute));
        currentMinute = currentMinute + 5;
    }

    return arrMinutes;
}

/**
 * Reviver function for JSON.parse which recursively parses a json string in object field ending with '*Json'
 */
function jsonFieldReviver(key, value) {
    const pattern = /^\S*[Jj]son$/; // Matches 'Json' at end of line
    if (pattern.test(key)) {
        return JSON.parse(value);
    }
    return value;
}

/**
 * Sorts an array of objects by descriptor field, using localeCompare for string fields
 * @param {Array} data - Array of objects to sor
 * @param {Object} descriptors - Object of sort descriptor, with field and dir properties
 * @param {string} locale - Locale to use for string comparison
 * @returns {Array} - Sorted array
 */
function orderByLocale(data, descriptors, locale = 'en') {
    return data.slice().sort((a, b) => {
        for (const descriptor of descriptors) {
            const { field, dir } = descriptor;
            const comparison = a[field].localeCompare(b[field], locale);
            if (comparison !== 0) {
                return dir === "asc" ? comparison : -comparison;
            }
        }
        return 0;
    });
}

async function sleep(msec = 1000) {
    return new Promise(resolve => setTimeout(resolve, msec));
}

export {
    getTimeHours,
    getTimeMinutes,
    jsonFieldReviver,
    orderByLocale,
    sleep
}
